module.exports = __webpack_public_path__ + "static/media/013-backward.bd326174.svg";